import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import TextInput from '../../../components/basic/TextInput';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};

const loadDialogStyle = {
    zIndex: '999999999'
}

class POSCardPaymentStatusDialog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        return (
            <div>
                <DialogInput
                    title="Has the payment completed?"
                    modal={false}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    style={loadDialogStyle}>
                    {
                        this.props.payFirmaEnabled ?
                            <p className="pa-2 text-center">
                                {t('pos.cardPaymentStatusDialog.checkDebitMachine')} <br />
                                {t('pos.cardPaymentStatusDialog.selectBackArrow')}<br />
                                {t('pos.cardPaymentStatusDialog.enterPassword')}<br />
                                {t('pos.cardPaymentStatusDialog.selectApp')}<br />
                                {t('pos.cardPaymentStatusDialog.screenDisplay')}
                            </p>
                            : ""
                    }
                    <p className="pa-2 text-center">{t('pos.cardPaymentStatusDialog.manuallyMoveForward')}</p>
                    
                    <div>
                        {
                            this.props.settings.pinPadPaymentManagerApproval ?
                                <div className="row">
                                    <br />
                                    <div className="alert alert-danger">
                                        <p>{t('pos.cardPaymentStatusDialog.managerApprovalNeeded')}</p>
                                    </div>
                                    <h4 className="credential_title">{t('common.credentialsTitle')}</h4>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <TextInput name={`PinpadPaymentApprovalUsername`}
                                                fullWidth={true}
                                                label={t('common.mgmtTeamUserName')}
                                                floatingLabelText={t('common.mgmtTeamUserName')}
                                                hintText={t('common.mgmtTeamUserName')} />
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <TextInput name={`PinpadPaymentApprovalPassword`}
                                                type="password"
                                                fullWidth={true}
                                                label={t('common.mgmtTeamPwd')}
                                                floatingLabelText={t('common.mgmtTeamPwd')}
                                                hintText={t('common.mgmtTeamPwd')}
                                                maxLength={30} />
                                        </div>
                                    </div>
                                    <div>
                                        <h4><b>{t('pos.cardPaymentStatusDialog.orBy')} {t('common.pinCode')}</b></h4>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <TextInput name={`PinpadPaymentApprovalPinCode`} hintText={t('common.password')} fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ""
                        }
                    </div>
                    
                    
                    <Button
                        key={1}
                        label={t('pos.cardPaymentStatusDialog.declined')}
                        className="bg-red"
                        primary={true}
                        onTouchTap={() => this.props.declined()}
                    />
                    <Button
                        key={3}
                        label={t('pos.cardPaymentStatusDialog.approved')}
                        className="pull-right bg-light-green"
                        primary={true}
                        onTouchTap={() => this.props.settings.pinPadPaymentManagerApproval ? this.props.managerApproval() : this.props.approved()}
                    />
                </DialogInput>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        payFirmaEnabled: state.common.applicationSettings.payFirmaEnabled,
        settings: state.common.applicationSettings
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCardPaymentStatusDialog));
